/*
    BEEP BOP BOOP - I AM AN AUTO GENERATED FILE - DO NOT EDIT ME MANUALLY
*/


// Name: Permissions JSON Schemas 

const _ORGANIZATION_JSON_SCHEMA = {
    "$ref": "#/definitions/OrganizationSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "OrganizationSchema": {
            "additionalProperties": false,
            "properties": {
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "description": {
                    "maxLength": 2048,
                    "title": "Description",
                    "type": "string"
                },
                "disabled": {
                    "title": "Disabled",
                    "type": "boolean"
                },
                "do_not_create_permissions": {
                    "title": "Do Not Create Permissions",
                    "type": "boolean"
                },
                "eminent_organization_uid": {
                    "reference_type": "uuid",
                    "title": "Eminent Organization Uid",
                    "type": "string",
                    "uid_resource_type": "organization"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "name": {
                    "maxLength": 256,
                    "minLength": 3,
                    "title": "Name",
                    "type": "string"
                },
                "organization_uid": {
                    "reference_type": "uuid",
                    "title": "Organization Uid",
                    "type": "string",
                    "uid_resource_type": "organization"
                },
                "owner_account_uid_for_resources": {
                    "reference_type": "uuid",
                    "title": "Owner Account Uid For Resources",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "parent_organization_uid": {
                    "reference_type": "uuid",
                    "title": "Parent Organization Uid",
                    "type": "string",
                    "uid_resource_type": "organization"
                }
            },
            "required": [
                "description",
                "disabled",
                "do_not_create_permissions",
                "eminent_organization_uid",
                "name",
                "organization_uid",
                "owner_account_uid_for_resources",
                "parent_organization_uid"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _ORGANIZATION_RESOURCE_PERMISSION_RULE_JSON_SCHEMA = {
    "$ref": "#/definitions/OrganizationResourcePermissionRuleSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "OrganizationResourcePermissionRuleSchema": {
            "additionalProperties": false,
            "properties": {
                "account_permissions": {
                    "items": {
                        "title": "account_permissions",
                        "type": "string"
                    },
                    "title": "Account Permissions",
                    "type": "array"
                },
                "account_uids_to_get_permissions": {
                    "items": {
                        "title": "account_uids_to_get_permissions",
                        "type": "string"
                    },
                    "title": "Account Uids To Get Permissions",
                    "type": "array"
                },
                "attribute_names": {
                    "items": {
                        "title": "attribute_names",
                        "type": "string"
                    },
                    "title": "Attribute Names",
                    "type": "array"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "description": {
                    "maxLength": 256,
                    "title": "Description",
                    "type": "string"
                },
                "disabled": {
                    "title": "Disabled",
                    "type": "boolean"
                },
                "eminent_organization_uid": {
                    "reference_type": "uuid",
                    "title": "Eminent Organization Uid",
                    "type": "string",
                    "uid_resource_type": "organization"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "match_value_types": {
                    "items": {
                        "class_name": "CommonType",
                        "enum": [
                            "str",
                            "int",
                            "uuid"
                        ],
                        "reference_type": "enum",
                        "type": "string"
                    },
                    "title": "Match Value Types",
                    "type": "array"
                },
                "match_values": {
                    "items": {
                        "title": "match_values",
                        "type": "string"
                    },
                    "title": "Match Values",
                    "type": "array"
                },
                "name": {
                    "maxLength": 64,
                    "minLength": 3,
                    "title": "Name",
                    "type": "string"
                },
                "operator_match_type": {
                    "class_name": "ResourcePermissionMatchType",
                    "enum": [
                        "all",
                        "any",
                        "none"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "operator_type": {
                    "class_name": "CommonOperatorType",
                    "enum": [
                        "lt",
                        "le",
                        "eq",
                        "ne",
                        "ge",
                        "gt"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "organization_permissions": {
                    "items": {
                        "title": "organization_permissions",
                        "type": "string"
                    },
                    "title": "Organization Permissions",
                    "type": "array"
                },
                "organization_uids_to_get_permissions": {
                    "items": {
                        "title": "organization_uids_to_get_permissions",
                        "type": "string"
                    },
                    "title": "Organization Uids To Get Permissions",
                    "type": "array"
                },
                "resource_type": {
                    "class_name": "ResourceType",
                    "enum": [
                        "unknown_resource_type",
                        "user_account",
                        "user_account_balance",
                        "user_account_balance_source",
                        "user_history_entry",
                        "balance_change_log",
                        "international_user_bank_account",
                        "us_domestic_user_bank_account",
                        "user_bank_account_delta",
                        "user_account_settings",
                        "user_account_admin_ghost",
                        "user_account_finalization",
                        "third_party_user_account_mapping",
                        "previous_email_address",
                        "pending_email_change",
                        "archived_pending_email_change",
                        "password",
                        "expired_password",
                        "password_reset",
                        "deposit",
                        "deposit_invite",
                        "deposit_adjustment",
                        "deposit_interest",
                        "deposit_history_entry",
                        "deposit_close_request",
                        "deposit_user_stats",
                        "deposit_bank_mapping",
                        "deposits_bulk_import",
                        "deposit_interest_log",
                        "archived_deposit_close_request",
                        "deposit_withheld_funds",
                        "pmc_report_timetable",
                        "deposit_group",
                        "deposit_post_close_adjustment",
                        "deposit_user_group",
                        "property_group",
                        "property_user_group",
                        "dispute",
                        "dispute_split",
                        "dispute_intervention_request",
                        "property",
                        "property_address",
                        "compliance",
                        "compliance_rule",
                        "compliance_history",
                        "email_template",
                        "email_verification",
                        "email_verification_record",
                        "email_event",
                        "sent_email",
                        "mailbox",
                        "mailbox_meta_data",
                        "mailbox_message",
                        "permission_entry",
                        "permission_log_entry",
                        "permissions_organization_settings",
                        "resource_permissions",
                        "organization",
                        "organization_resource_permission_rule",
                        "invoice",
                        "invoice_item",
                        "payment_request",
                        "stripe_payment_log",
                        "user_withdraw",
                        "priority_ach_payment",
                        "priority_ach_recurring_payment",
                        "loan_application",
                        "loan_system_info",
                        "loan",
                        "loan_history",
                        "loan_payment_log",
                        "stripe_webhook_log",
                        "user_account_payment_provider_info",
                        "sezzle_order",
                        "sezzle_webhook_event",
                        "bank_account",
                        "bank_account_historical_interest_rate",
                        "bank_account_interest",
                        "bank_account_balance_record",
                        "bank_transfer",
                        "bulk_funds_transfer",
                        "funds_lock",
                        "funds_lock_release_log",
                        "released_funds_lock",
                        "balance_source_transfer",
                        "credit_user_account_log",
                        "event",
                        "event_hook",
                        "notification",
                        "action_item",
                        "update_log_entry",
                        "storage_file",
                        "attached_storage_files",
                        "pre_uploaded_file",
                        "system_history_entry",
                        "snapshot",
                        "ip_address",
                        "known_ip_address",
                        "user_agent",
                        "known_user_agent",
                        "basic_user_account_info",
                        "system_stats",
                        "resource_note",
                        "deposify_tag",
                        "permanent_link",
                        "online_user",
                        "frontend_general_settings",
                        "yardi_screening_works_pro_xml",
                        "yardi_voyager_xml",
                        "yardi_voyager_transaction",
                        "yardi_voyager_resident",
                        "yardi_voyager_resident_custom_column",
                        "yardi_voyager_property_unit",
                        "yardi_voyager_property",
                        "yardi_voyager_pmc_service_interface_version",
                        "yardi_voyager_pmc",
                        "yardi_voyager_pmc_credentials",
                        "yardi_voyager_pet",
                        "yardi_voyager_ils_guest_card_event",
                        "yardi_voyager_charge",
                        "yardi_voyager_charge_code",
                        "yardi_voyager_deposit_create_intent",
                        "yardi_voyager_deposit_close_intent",
                        "yardi_voyager_deposit_withhold_intent",
                        "yardi_voyager_event",
                        "yardi_voyager_flex_deposit_intent",
                        "yardi_voyager_phone",
                        "yardi_voyager_other_occupant",
                        "yardi_voyager_pmc_custom_column_settings",
                        "yardi_voyager_pmc_stats",
                        "yardi_voyager_pmc_stats_collector",
                        "yardi_voyager_active_scan_log_entry",
                        "yardi_voyager_system_settings"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "rule_type": {
                    "class_name": "ResourcePermissionRuleType",
                    "enum": [
                        "resource_type",
                        "attribute"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "rule_uid": {
                    "reference_type": "uuid",
                    "title": "Rule Uid",
                    "type": "string",
                    "uid_resource_type": "organization_resource_permission_rule"
                },
                "triggering_account_uids": {
                    "items": {
                        "title": "triggering_account_uids",
                        "type": "string"
                    },
                    "title": "Triggering Account Uids",
                    "type": "array"
                },
                "triggering_organization_uids": {
                    "items": {
                        "title": "triggering_organization_uids",
                        "type": "string"
                    },
                    "title": "Triggering Organization Uids",
                    "type": "array"
                }
            },
            "required": [
                "account_permissions",
                "account_uids_to_get_permissions",
                "attribute_names",
                "description",
                "disabled",
                "eminent_organization_uid",
                "match_value_types",
                "match_values",
                "name",
                "operator_match_type",
                "operator_type",
                "organization_permissions",
                "organization_uids_to_get_permissions",
                "resource_type",
                "rule_type",
                "rule_uid",
                "triggering_account_uids",
                "triggering_organization_uids"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _PERMISSIONS_ORGANIZATION_SETTINGS_JSON_SCHEMA = {
    "$ref": "#/definitions/PermissionsOrganizationSettingsSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "PermissionsOrganizationSettingsSchema": {
            "additionalProperties": false,
            "properties": {
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "disable_auto_permission_create": {
                    "title": "Disable Auto Permission Create",
                    "type": "boolean"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "organization_uid": {
                    "reference_type": "uuid",
                    "title": "Organization Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                }
            },
            "required": [
                "created_timestamp",
                "disable_auto_permission_create",
                "last_updated_timestamp",
                "organization_uid"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _PERMISSION_ENTRY_JSON_SCHEMA = {
    "$ref": "#/definitions/PermissionEntrySchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "PermissionEntrySchema": {
            "additionalProperties": false,
            "properties": {
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "disabled": {
                    "title": "Disabled",
                    "type": "boolean"
                },
                "has_notes": {
                    "title": "Has Notes",
                    "type": "boolean"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "owner_type": {
                    "class_name": "PermissionOwner",
                    "enum": [
                        "redirect",
                        "account_uid",
                        "organization_uid"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "owner_uid": {
                    "reference_type": "uuid",
                    "title": "Owner Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "permission_uid": {
                    "reference_type": "uuid",
                    "title": "Permission Uid",
                    "type": "string",
                    "uid_resource_type": "permission_entry"
                },
                "permissions": {
                    "items": {
                        "format": "integer",
                        "title": "permissions",
                        "type": "number"
                    },
                    "title": "Permissions",
                    "type": "array"
                },
                "resource_type": {
                    "class_name": "ResourceType",
                    "enum": [
                        "unknown_resource_type",
                        "user_account",
                        "user_account_balance",
                        "user_account_balance_source",
                        "user_history_entry",
                        "balance_change_log",
                        "international_user_bank_account",
                        "us_domestic_user_bank_account",
                        "user_bank_account_delta",
                        "user_account_settings",
                        "user_account_admin_ghost",
                        "user_account_finalization",
                        "third_party_user_account_mapping",
                        "previous_email_address",
                        "pending_email_change",
                        "archived_pending_email_change",
                        "password",
                        "expired_password",
                        "password_reset",
                        "deposit",
                        "deposit_invite",
                        "deposit_adjustment",
                        "deposit_interest",
                        "deposit_history_entry",
                        "deposit_close_request",
                        "deposit_user_stats",
                        "deposit_bank_mapping",
                        "deposits_bulk_import",
                        "deposit_interest_log",
                        "archived_deposit_close_request",
                        "deposit_withheld_funds",
                        "pmc_report_timetable",
                        "deposit_group",
                        "deposit_post_close_adjustment",
                        "deposit_user_group",
                        "property_group",
                        "property_user_group",
                        "dispute",
                        "dispute_split",
                        "dispute_intervention_request",
                        "property",
                        "property_address",
                        "compliance",
                        "compliance_rule",
                        "compliance_history",
                        "email_template",
                        "email_verification",
                        "email_verification_record",
                        "email_event",
                        "sent_email",
                        "mailbox",
                        "mailbox_meta_data",
                        "mailbox_message",
                        "permission_entry",
                        "permission_log_entry",
                        "permissions_organization_settings",
                        "resource_permissions",
                        "organization",
                        "organization_resource_permission_rule",
                        "invoice",
                        "invoice_item",
                        "payment_request",
                        "stripe_payment_log",
                        "user_withdraw",
                        "priority_ach_payment",
                        "priority_ach_recurring_payment",
                        "loan_application",
                        "loan_system_info",
                        "loan",
                        "loan_history",
                        "loan_payment_log",
                        "stripe_webhook_log",
                        "user_account_payment_provider_info",
                        "sezzle_order",
                        "sezzle_webhook_event",
                        "bank_account",
                        "bank_account_historical_interest_rate",
                        "bank_account_interest",
                        "bank_account_balance_record",
                        "bank_transfer",
                        "bulk_funds_transfer",
                        "funds_lock",
                        "funds_lock_release_log",
                        "released_funds_lock",
                        "balance_source_transfer",
                        "credit_user_account_log",
                        "event",
                        "event_hook",
                        "notification",
                        "action_item",
                        "update_log_entry",
                        "storage_file",
                        "attached_storage_files",
                        "pre_uploaded_file",
                        "system_history_entry",
                        "snapshot",
                        "ip_address",
                        "known_ip_address",
                        "user_agent",
                        "known_user_agent",
                        "basic_user_account_info",
                        "system_stats",
                        "resource_note",
                        "deposify_tag",
                        "permanent_link",
                        "online_user",
                        "frontend_general_settings",
                        "yardi_screening_works_pro_xml",
                        "yardi_voyager_xml",
                        "yardi_voyager_transaction",
                        "yardi_voyager_resident",
                        "yardi_voyager_resident_custom_column",
                        "yardi_voyager_property_unit",
                        "yardi_voyager_property",
                        "yardi_voyager_pmc_service_interface_version",
                        "yardi_voyager_pmc",
                        "yardi_voyager_pmc_credentials",
                        "yardi_voyager_pet",
                        "yardi_voyager_ils_guest_card_event",
                        "yardi_voyager_charge",
                        "yardi_voyager_charge_code",
                        "yardi_voyager_deposit_create_intent",
                        "yardi_voyager_deposit_close_intent",
                        "yardi_voyager_deposit_withhold_intent",
                        "yardi_voyager_event",
                        "yardi_voyager_flex_deposit_intent",
                        "yardi_voyager_phone",
                        "yardi_voyager_other_occupant",
                        "yardi_voyager_pmc_custom_column_settings",
                        "yardi_voyager_pmc_stats",
                        "yardi_voyager_pmc_stats_collector",
                        "yardi_voyager_active_scan_log_entry",
                        "yardi_voyager_system_settings"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "resource_uid": {
                    "reference_type": "uuid",
                    "title": "Resource Uid",
                    "type": "string"
                }
            },
            "required": [
                "created_timestamp",
                "disabled",
                "has_notes",
                "last_updated_timestamp",
                "owner_type",
                "owner_uid",
                "permission_uid",
                "permissions",
                "resource_type",
                "resource_uid"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _PERMISSION_LOG_ENTRY_JSON_SCHEMA = {
    "$ref": "#/definitions/PermissionLogEntrySchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "PermissionLogEntrySchema": {
            "additionalProperties": false,
            "properties": {
                "account_uid": {
                    "reference_type": "uuid",
                    "title": "Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "log_entry_uid": {
                    "reference_type": "uuid",
                    "title": "Log Entry Uid",
                    "type": "string",
                    "uid_resource_type": "permission_log_entry"
                },
                "log_version": {
                    "format": "integer",
                    "title": "Log Version",
                    "type": "number"
                },
                "needed_permissions": {
                    "items": {
                        "format": "integer",
                        "title": "needed_permissions",
                        "type": "number"
                    },
                    "title": "Needed Permissions",
                    "type": "array"
                },
                "organization_uid_used": {
                    "title": "Organization Uid Used",
                    "type": "string"
                },
                "permission_decision": {
                    "class_name": "PermissionDecision",
                    "enum": [
                        "permitted",
                        "rejected_bad_data",
                        "rejected_acc_banned",
                        "rejected_acc_email_not_verified",
                        "rejected_permission_not_found",
                        "rejected"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "resource_type": {
                    "class_name": "ResourceType",
                    "enum": [
                        "unknown_resource_type",
                        "user_account",
                        "user_account_balance",
                        "user_account_balance_source",
                        "user_history_entry",
                        "balance_change_log",
                        "international_user_bank_account",
                        "us_domestic_user_bank_account",
                        "user_bank_account_delta",
                        "user_account_settings",
                        "user_account_admin_ghost",
                        "user_account_finalization",
                        "third_party_user_account_mapping",
                        "previous_email_address",
                        "pending_email_change",
                        "archived_pending_email_change",
                        "password",
                        "expired_password",
                        "password_reset",
                        "deposit",
                        "deposit_invite",
                        "deposit_adjustment",
                        "deposit_interest",
                        "deposit_history_entry",
                        "deposit_close_request",
                        "deposit_user_stats",
                        "deposit_bank_mapping",
                        "deposits_bulk_import",
                        "deposit_interest_log",
                        "archived_deposit_close_request",
                        "deposit_withheld_funds",
                        "pmc_report_timetable",
                        "deposit_group",
                        "deposit_post_close_adjustment",
                        "deposit_user_group",
                        "property_group",
                        "property_user_group",
                        "dispute",
                        "dispute_split",
                        "dispute_intervention_request",
                        "property",
                        "property_address",
                        "compliance",
                        "compliance_rule",
                        "compliance_history",
                        "email_template",
                        "email_verification",
                        "email_verification_record",
                        "email_event",
                        "sent_email",
                        "mailbox",
                        "mailbox_meta_data",
                        "mailbox_message",
                        "permission_entry",
                        "permission_log_entry",
                        "permissions_organization_settings",
                        "resource_permissions",
                        "organization",
                        "organization_resource_permission_rule",
                        "invoice",
                        "invoice_item",
                        "payment_request",
                        "stripe_payment_log",
                        "user_withdraw",
                        "priority_ach_payment",
                        "priority_ach_recurring_payment",
                        "loan_application",
                        "loan_system_info",
                        "loan",
                        "loan_history",
                        "loan_payment_log",
                        "stripe_webhook_log",
                        "user_account_payment_provider_info",
                        "sezzle_order",
                        "sezzle_webhook_event",
                        "bank_account",
                        "bank_account_historical_interest_rate",
                        "bank_account_interest",
                        "bank_account_balance_record",
                        "bank_transfer",
                        "bulk_funds_transfer",
                        "funds_lock",
                        "funds_lock_release_log",
                        "released_funds_lock",
                        "balance_source_transfer",
                        "credit_user_account_log",
                        "event",
                        "event_hook",
                        "notification",
                        "action_item",
                        "update_log_entry",
                        "storage_file",
                        "attached_storage_files",
                        "pre_uploaded_file",
                        "system_history_entry",
                        "snapshot",
                        "ip_address",
                        "known_ip_address",
                        "user_agent",
                        "known_user_agent",
                        "basic_user_account_info",
                        "system_stats",
                        "resource_note",
                        "deposify_tag",
                        "permanent_link",
                        "online_user",
                        "frontend_general_settings",
                        "yardi_screening_works_pro_xml",
                        "yardi_voyager_xml",
                        "yardi_voyager_transaction",
                        "yardi_voyager_resident",
                        "yardi_voyager_resident_custom_column",
                        "yardi_voyager_property_unit",
                        "yardi_voyager_property",
                        "yardi_voyager_pmc_service_interface_version",
                        "yardi_voyager_pmc",
                        "yardi_voyager_pmc_credentials",
                        "yardi_voyager_pet",
                        "yardi_voyager_ils_guest_card_event",
                        "yardi_voyager_charge",
                        "yardi_voyager_charge_code",
                        "yardi_voyager_deposit_create_intent",
                        "yardi_voyager_deposit_close_intent",
                        "yardi_voyager_deposit_withhold_intent",
                        "yardi_voyager_event",
                        "yardi_voyager_flex_deposit_intent",
                        "yardi_voyager_phone",
                        "yardi_voyager_other_occupant",
                        "yardi_voyager_pmc_custom_column_settings",
                        "yardi_voyager_pmc_stats",
                        "yardi_voyager_pmc_stats_collector",
                        "yardi_voyager_active_scan_log_entry",
                        "yardi_voyager_system_settings"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "resource_uid": {
                    "reference_type": "uuid",
                    "title": "Resource Uid",
                    "type": "string"
                }
            },
            "required": [
                "account_uid",
                "created_timestamp",
                "last_updated_timestamp",
                "log_entry_uid",
                "log_version",
                "needed_permissions",
                "organization_uid_used",
                "permission_decision",
                "resource_type",
                "resource_uid"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _RESOURCE_PERMISSION_JSON_SCHEMA = {
    "$ref": "#/definitions/ResourcePermissionSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "ResourcePermissionSchema": {
            "additionalProperties": false,
            "properties": {
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "disabled": {
                    "title": "Disabled",
                    "type": "boolean"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "owner_type": {
                    "class_name": "PermissionOwner",
                    "enum": [
                        "redirect",
                        "account_uid",
                        "organization_uid"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "owner_uid": {
                    "title": "Owner Uid",
                    "type": "string"
                },
                "parent_resource_uid": {
                    "title": "Parent Resource Uid",
                    "type": "string"
                },
                "permission_uid": {
                    "reference_type": "uuid",
                    "title": "Permission Uid",
                    "type": "string",
                    "uid_resource_type": "resource_permissions"
                },
                "permissions": {
                    "items": {
                        "title": "permissions",
                        "type": "string"
                    },
                    "title": "Permissions",
                    "type": "array"
                },
                "resource_type": {
                    "class_name": "ResourceType",
                    "enum": [
                        "unknown_resource_type",
                        "user_account",
                        "user_account_balance",
                        "user_account_balance_source",
                        "user_history_entry",
                        "balance_change_log",
                        "international_user_bank_account",
                        "us_domestic_user_bank_account",
                        "user_bank_account_delta",
                        "user_account_settings",
                        "user_account_admin_ghost",
                        "user_account_finalization",
                        "third_party_user_account_mapping",
                        "previous_email_address",
                        "pending_email_change",
                        "archived_pending_email_change",
                        "password",
                        "expired_password",
                        "password_reset",
                        "deposit",
                        "deposit_invite",
                        "deposit_adjustment",
                        "deposit_interest",
                        "deposit_history_entry",
                        "deposit_close_request",
                        "deposit_user_stats",
                        "deposit_bank_mapping",
                        "deposits_bulk_import",
                        "deposit_interest_log",
                        "archived_deposit_close_request",
                        "deposit_withheld_funds",
                        "pmc_report_timetable",
                        "deposit_group",
                        "deposit_post_close_adjustment",
                        "deposit_user_group",
                        "property_group",
                        "property_user_group",
                        "dispute",
                        "dispute_split",
                        "dispute_intervention_request",
                        "property",
                        "property_address",
                        "compliance",
                        "compliance_rule",
                        "compliance_history",
                        "email_template",
                        "email_verification",
                        "email_verification_record",
                        "email_event",
                        "sent_email",
                        "mailbox",
                        "mailbox_meta_data",
                        "mailbox_message",
                        "permission_entry",
                        "permission_log_entry",
                        "permissions_organization_settings",
                        "resource_permissions",
                        "organization",
                        "organization_resource_permission_rule",
                        "invoice",
                        "invoice_item",
                        "payment_request",
                        "stripe_payment_log",
                        "user_withdraw",
                        "priority_ach_payment",
                        "priority_ach_recurring_payment",
                        "loan_application",
                        "loan_system_info",
                        "loan",
                        "loan_history",
                        "loan_payment_log",
                        "stripe_webhook_log",
                        "user_account_payment_provider_info",
                        "sezzle_order",
                        "sezzle_webhook_event",
                        "bank_account",
                        "bank_account_historical_interest_rate",
                        "bank_account_interest",
                        "bank_account_balance_record",
                        "bank_transfer",
                        "bulk_funds_transfer",
                        "funds_lock",
                        "funds_lock_release_log",
                        "released_funds_lock",
                        "balance_source_transfer",
                        "credit_user_account_log",
                        "event",
                        "event_hook",
                        "notification",
                        "action_item",
                        "update_log_entry",
                        "storage_file",
                        "attached_storage_files",
                        "pre_uploaded_file",
                        "system_history_entry",
                        "snapshot",
                        "ip_address",
                        "known_ip_address",
                        "user_agent",
                        "known_user_agent",
                        "basic_user_account_info",
                        "system_stats",
                        "resource_note",
                        "deposify_tag",
                        "permanent_link",
                        "online_user",
                        "frontend_general_settings",
                        "yardi_screening_works_pro_xml",
                        "yardi_voyager_xml",
                        "yardi_voyager_transaction",
                        "yardi_voyager_resident",
                        "yardi_voyager_resident_custom_column",
                        "yardi_voyager_property_unit",
                        "yardi_voyager_property",
                        "yardi_voyager_pmc_service_interface_version",
                        "yardi_voyager_pmc",
                        "yardi_voyager_pmc_credentials",
                        "yardi_voyager_pet",
                        "yardi_voyager_ils_guest_card_event",
                        "yardi_voyager_charge",
                        "yardi_voyager_charge_code",
                        "yardi_voyager_deposit_create_intent",
                        "yardi_voyager_deposit_close_intent",
                        "yardi_voyager_deposit_withhold_intent",
                        "yardi_voyager_event",
                        "yardi_voyager_flex_deposit_intent",
                        "yardi_voyager_phone",
                        "yardi_voyager_other_occupant",
                        "yardi_voyager_pmc_custom_column_settings",
                        "yardi_voyager_pmc_stats",
                        "yardi_voyager_pmc_stats_collector",
                        "yardi_voyager_active_scan_log_entry",
                        "yardi_voyager_system_settings"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "resource_uid": {
                    "reference_type": "uuid",
                    "title": "Resource Uid",
                    "type": "string"
                }
            },
            "required": [
                "disabled",
                "owner_type",
                "owner_uid",
                "parent_resource_uid",
                "permission_uid",
                "permissions",
                "resource_type",
                "resource_uid"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};


export const ORGANIZATION_JSON_SCHEMA = _ORGANIZATION_JSON_SCHEMA.definitions.OrganizationSchema;
export const ORGANIZATION_RESOURCE_PERMISSION_RULE_JSON_SCHEMA = _ORGANIZATION_RESOURCE_PERMISSION_RULE_JSON_SCHEMA.definitions.OrganizationResourcePermissionRuleSchema;
export const PERMISSIONS_ORGANIZATION_SETTINGS_JSON_SCHEMA = _PERMISSIONS_ORGANIZATION_SETTINGS_JSON_SCHEMA.definitions.PermissionsOrganizationSettingsSchema;
export const PERMISSION_ENTRY_JSON_SCHEMA = _PERMISSION_ENTRY_JSON_SCHEMA.definitions.PermissionEntrySchema;
export const PERMISSION_LOG_ENTRY_JSON_SCHEMA = _PERMISSION_LOG_ENTRY_JSON_SCHEMA.definitions.PermissionLogEntrySchema;
export const RESOURCE_PERMISSION_JSON_SCHEMA = _RESOURCE_PERMISSION_JSON_SCHEMA.definitions.ResourcePermissionSchema;
